import React, { useEffect, useState } from "react";
import { AssortGroup } from "../../../models/AssortGroup";
import useTicketsByAssortGroup from "./hooks/useTicketsByAssortGroup";
import "./style.scss";
import "../../../../style/block.scss";
import "../../../../style/buttons.scss";
import "../../../../style/feature.scss";
import { HiOutlineTicket } from "react-icons/hi";
import TicketLineSummary from "../../Universal/TicketLineSummary";
import PreBasketSummary from "../../Universal/PreBasketSummary";
import usePreBasket from "../../Universal/hooks/usePreBasket";
import useBasketManager from "../../FinalizePage/hooks/useBasketManager";
import { useTranslation } from "react-i18next";
import EAProductBanner from "../../shared/ProductBanner/EAProductBanner";
import useDesktopSize from "../../../../utils/hooks/useDesktopSize";
import getId from "../../../../utils/getId";
import useGetLowestPrice from "../../../../utils/hooks/useGetLowestPrice";
import { SaleStep } from "../../../store/stepSaleConfig/stepSaleConfigReducer";
import PassLineSummary from "../../Universal/PassLineSummary";

interface IProps {
  item: AssortGroup;
  saleStep?: SaleStep;
  sortType: "assortGroup" | "colorGroup" | "shapeGroup" | "colorGroupPasses" | "allParams";
  allParams?: any;
  highlightBanner?: boolean;
  bannerLabel?: string;
  customMainPrice?: string;
  crossedPrice?: string;
  additionalPriceInfo?: string;
  highlightedFeatures?: string[];
  passSaleVariant?: boolean;
  buttonCustomTitle?: string;
}

const LimitedTicketBlock: React.FC<IProps> = ({
  item,
  saleStep,
  sortType,
  allParams = {},
  highlightBanner,
  bannerLabel,
  customMainPrice,
  crossedPrice,
  additionalPriceInfo,
  highlightedFeatures,
  passSaleVariant,
  buttonCustomTitle,
}) => {
  const { t } = useTranslation();
  const {
    requestGetTicketsByAssortGroup,
    requestGetTicketsByColor,
    requestGetTicketsByShape,
    requestGetTicketsByAllParams,
    requestGetPassesByShape,
    requestGetPassesByColor,
    passesAndAssorts,
  } = useTicketsByAssortGroup();
  const [showTickets, setShowTicket] = useState(false);
  const isDesktop = useDesktopSize();
  const { preBasket, addItemToBasket, removeItemFromBasket, clearBasket, setItemQuantity } = usePreBasket();
  const { getBasket } = useBasketManager();
  const handleDeleteBasket = () => {
    clearBasket();
    setTimeout(() => {
      getBasket();
    }, 200);
  };

  useEffect(() => {
    if (sortType === "assortGroup") {
      requestGetTicketsByAssortGroup(item.objectDb, item.objectId);
    }
    if (sortType === "colorGroup") {
      requestGetTicketsByColor(item.objectDb, item.objectId);
      requestGetPassesByColor(getId(item));
    }
    if (sortType === "shapeGroup") {
      requestGetTicketsByShape(item.objectDb, item.objectId);
      requestGetPassesByShape(getId(item));
    }
    // if (sortType === "colorGroupPasses") {
    //   requestGetPassesByColor(getId(item));
    // }
    if (sortType === "allParams") {
      requestGetTicketsByAllParams(allParams);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [item.objectId]);

  const getButtonTitle = () => {
    if (showTickets) {
      return `${t("schowaj_bilety")} (${passesAndAssorts.length})`;
    }
    return `${t("pokaz_bilety")} (${passesAndAssorts.length})`;
  };

  const handleOpenExpanded = () => {
    if (showTickets) {
      setShowTicket(false);
    } else {
      setShowTicket(true);
    }
  };

  const lowestPrice = useGetLowestPrice(passesAndAssorts, isDesktop, !customMainPrice);

  return (
    <>
      <EAProductBanner
        title={item.name}
        pictureUrl={item.pictureUrl}
        description={item.description}
        mainPrice={customMainPrice ? customMainPrice.replace("{{price}}", lowestPrice) : lowestPrice}
        crossedPrice={crossedPrice ? crossedPrice.replace("{{price}}", lowestPrice) : ""}
        buttonTitle={buttonCustomTitle ? buttonCustomTitle : getButtonTitle()}
        buttonStartIcon={<HiOutlineTicket />}
        buttonVariant={showTickets ? "outlined" : "filled"}
        expanded={showTickets}
        onClick={handleOpenExpanded}
        highlightBanner={highlightBanner}
        bannerLabel={bannerLabel}
        additionalPriceInfo={additionalPriceInfo}
        highlightedFeatures={highlightedFeatures}
        loginRequired={saleStep?.loginRequired}
      >
        <div className="single-event-tickets">
          {passSaleVariant === true ? (
            <>
              {passesAndAssorts.map((itemTicket, index) => (
                <div className="ticket-line-container" key={index}>
                  <PassLineSummary
                    item={itemTicket}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                  />
                </div>
              ))}
            </>
          ) : (
            <>
              {passesAndAssorts.map((itemTicket, index) => (
                <div className="ticket-line-container" key={index}>
                  <TicketLineSummary
                    item={itemTicket}
                    preBasket={preBasket}
                    addItemToBasket={addItemToBasket}
                    removeItemFromBasket={removeItemFromBasket}
                    setItemQuantity={setItemQuantity}
                    allowManualInput={true}
                  />
                </div>
              ))}
              <PreBasketSummary preBasket={preBasket} clearBasket={handleDeleteBasket} />
            </>
          )}
        </div>
      </EAProductBanner>
    </>
  );
};

export default LimitedTicketBlock;
